// src/api/functions/transaction/get-transactions.action.ts
import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'
import type { Transaction, TransactionFilters } from '@/api/typings/transaction.typing'

export function getTransactionsAction(filters: TransactionFilters = {}): Promise<ApiPaginationResponse<Transaction[]>> {
  const params = new URLSearchParams()

  if (filters.page) {
    params.append('page', String(filters.page))
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && key !== 'page') {
      params.append(`filter[${key}]`, String(value))
    }
  })

  const url = `/transactions?${params.toString()}`
  return api.get<ApiPaginationResponse<Transaction[]>>(url)
}
